import { FUNKIT_CONNECT_SUPPORTED_CHAINS_INFO, FUNKIT_CONNECT_SUPPORTED_CHECKOUT_CHAINS_INFO_LIST } from '@funkit/chains';
import type { Transport } from 'viem';
import { fallback, http } from 'viem';
import { polygon } from 'viem/chains';

// Mirrors getDefaultChains/getDefaultTransports from @funkit/connect (verified against 9.13.0 —
// re-diff its getDefaultConfig.ts on upgrade) using only the small @funkit/chains data package,
// so the wagmi config doesn't pull the ~2MB @funkit/connect entry into the startup bundle.

export const funkitCheckoutChains = FUNKIT_CONNECT_SUPPORTED_CHECKOUT_CHAINS_INFO_LIST;

export const funkitDefaultTransports = () => {
  const transports: Record<number, Transport> = {};
  for (const chain of funkitCheckoutChains) {
    const fallbackRpcs = FUNKIT_CONNECT_SUPPORTED_CHAINS_INFO[chain.id]?.fallbackRpcUrls;
    if (fallbackRpcs?.length) {
      const rpcs =
        chain.id === polygon.id ? fallbackRpcs.map((url) => http(url)) : [http(), ...fallbackRpcs.map((url) => http(url))];
      transports[chain.id] = fallback(rpcs);
    } else {
      transports[chain.id] = http();
    }
  }
  return transports;
};
